import apiClient from '@/lib/axios';
import type { PaymentImage } from '../types/jobPayment';

/**
 * Get all images for a job payment
 */
export const getPaymentImages = async (
  jobId: number,
  paymentId: number
): Promise<PaymentImage[]> => {
  const response = await apiClient.get<{ data: PaymentImage[] }>(
    `/jobs/${jobId}/payments/${paymentId}/images`
  );
  return response.data.data;
};

/**
 * Upload images for a job payment
 */
export const uploadPaymentImages = async (
  jobId: number,
  paymentId: number,
  files: File[]
): Promise<PaymentImage[]> => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });

  const response = await apiClient.post<{ data: PaymentImage[] }>(
    `/jobs/${jobId}/payments/${paymentId}/images`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data.data;
};

/**
 * Delete a payment image
 */
export const deletePaymentImage = async (
  jobId: number,
  paymentId: number,
  imageId: number
): Promise<void> => {
  await apiClient.delete(`/jobs/${jobId}/payments/${paymentId}/images/${imageId}`);
};

/**
 * Get the download URL for a payment image
 */
export const getPaymentImageUrl = (
  jobId: number,
  paymentId: number,
  imageId: number
): string => {
  return `/api/jobs/${jobId}/payments/${paymentId}/images/${imageId}`;
};
